import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-page mx-auto"},[_c(VCard,[_c(VCardTitle,[_c('div',{staticClass:"title font-weight-light",staticStyle:{"width":"100%"}},[_vm._v(" Account Information ")])]),_c(VDivider),_c(VCardText,[_c('PersonalContactInformationForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }